import { format } from 'date-fns';
import { getDateWithSpecificFormat } from '../../../../data-transform';
import { getQuoteTypeText, getStatusDescriptionFromStatusValue } from '../../../../../utils/utility';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import actions from '../../../../../store/actions';

const createdStatusOptions = [
    { id: "ACCEPTED", label: "Accepted" },
    { id: "LOST", label: "Lost" },
    { id: "ON_HOLD", label: "On Hold" },
    { id: "POSTPONED_TO_NEXT_QUARTER", label: "Postponed To Next Quarter" }
];

const partiallyCreatedStatusOptions = [
    { id: "POSTPONED_TO_NEXT_QUARTER", label: "Postponed To Next Quarter" }
];

const postponedToNextQuarterStatusOptions = [
    { id: "ACCEPTED", label: "Accepted" },
    { id: "LOST", label: "Lost" },
    { id: "ON_HOLD", label: "On Hold" },
];

const vendorPricesPendingStatusOptions = [
    { id: "ON_HOLD", label: "On Hold" }
];
const onHoldStatusOptions = [
    { id: "VENDOR_PRICES_PENDING", label: "Vendor Prices Pending" }
];
const revitalizeHPPricesPendingOptions = [
    { id: "REQUESTED", label: "Requested" }
];

const onHoldStatusCreationOptions = [
    { id: 'CREATED', label: "Created" },
    { id: "ACCEPTED", label: "Accepted" },
    { id: "LOST", label: "Lost" },
];

const npsSurveySentOptions = [
    { id: '', label: "Select" },
    { id: 'YES', label: "Yes" },
    { id: "NO", label: "No" },
];

const QUOTE_EDIT_DISABLED = ['ACCEPTED', 'LOST', 'DRAFT', 'EXPIRED'];

const getReportingYearOptions = (createdDate) => {
    const createdYear = new Date(createdDate).getFullYear();
    const currentYearNumber = new Date().getFullYear();
    const options = [];
    for (let year = createdYear; year <= currentYearNumber; year++) {
        options.push({ id: `FY${year.toString().slice(-2)}`, label: `FY${year.toString().slice(-2)}` });
    }
    return options;
}

const getReportingQuarterOptions = (reportingYear) => {
    if (reportingYear === '') return [];
    const year = reportingYear?.slice(2) || new Date().getFullYear().toString().slice(-2);
    const options = [];
    for (let quarter = 1; quarter <= 4; quarter++) {
        options.push({ id: `FY${year}Q${quarter}`, label: `FY${year}Q${quarter}` });
    }
    return options;
}

export default function ControlTowerInitialQuotesColumnSpecification(config) {
    const { rejectionReasonOptions, quoteList } = config.data;
    const { directCustomerQuote } = useSelector(state => state);
    const { requestTypeOptions = [], leadOriginOptions = [], leadSourceOptions = [] } = directCustomerQuote;
    const dispatch = useDispatch();

    useEffect(() => {
        if (!userProfile.ctProfiles.length) {
            dispatch(actions.userProfile.getCTList(userProfile.userId));
        }
    }, []);

    const getRejectionReasonOptions = () => {
        return rejectionReasonOptions.map(reason => ({
            id: reason, label: reason
        }))
    }

    const { quote, userProfile } = useSelector(state => state);
    const getControlTowerList = () => {
        return userProfile.ctProfiles.map(profile => ({
            id: profile.emailAddress, label: profile.emailAddress
        }))
    };

    const { quoteListCopy = [] } = quote;
    if (!config.data) return null;
    let ctResponsibleOptions = [];

    let result = {};
    let tableData = [];

    quoteList.forEach((quote, index) => {
        let row = [];
        const rowId = quote.quoteId;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            let columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;
            let clickHandler = null;

            let columnValue = null;
            let isDisabled = false;
            let linkDestination = null;
            let columnValueData = null;
            let isOverflowingContent = false;

            if (columnDataType === "link") {
                if (columnId === "quoteId" && quote.quoteId) {
                    columnValue = quote.quoteId;
                    linkDestination = '/quotes/control-tower-initial-quotes/' + quote.quoteId;
                }
            }
            else if (columnDataType === "string") {
                if (columnId === "quoteType") {
                    columnValue = getQuoteTypeText(quote.quoteType);
                }
                if (columnId === "geographicalScope") {
                    columnValue = quote.geographicalScope;
                }
                else if (columnId === "region") {
                    columnValue = quote.region;
                } else if (columnId === "internalHPComments") {
                    columnValue = quote.internalHPComments || "";
                    isOverflowingContent = true;
                }
                else if (columnId === "dateOfRequest") {
                    columnValue = getDateWithSpecificFormat(quote.requestDate) || "";
                }
                else if (columnId === "quoteCreationDate") {
                    columnValue = getDateWithSpecificFormat(quote.quoteCreationDate) || "";
                }
                else if (columnId === "numberOfAssets") {
                    columnValue = quote.assetQty || 0;
                }
                else if (columnId === "countriesRequested") {
                    columnValue = quote.countryList && quote.countryList.length ? quote.countryList.join() : "";
                    isOverflowingContent = true;
                }
                else if (columnId === "currencyCode") {
                    columnValue = quote.currencyCode || "";
                }
                else if (columnId === "quoteValidDate") {
                    columnValue = getDateWithSpecificFormat(quote.quoteValidDate) || "";
                }
                else if (columnId === "requestorType") {
                    columnValue = quote.requestorType || "";
                }
                else if (columnId === "selectedVendor") {
                    columnValue = quote.selectedVendors || "";
                    isOverflowingContent = true;
                }
                else if (columnId === "internalHPComment") {
                    columnValue = quote.internalHPComments || "";
                }
                else if (columnId === "revitalizeCountries") {
                    isDisabled = true;
                    if (quote.quoteType === 'DRS_REVITALIZE') {
                        columnValue = quote.revitalizeCountries || "";
                        isDisabled = false
                    }
                }
                else if (columnId === "numberOfRevitalizeAssets") {
                    isDisabled = true;
                    if (quote.quoteType === 'DRS_REVITALIZE') {
                        columnValue = quote.numberOfRevitalizeAssets || "";
                        isDisabled = false
                    }
                }
            }

            if (columnDataType === "select") {
                if (columnId === "requestType") {
                    columnValue = quote.requestType || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = [
                        { id: "", label: "Select" },
                        ...requestTypeOptions.map(option => ({ id: option, label: option }))
                    ];
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null
                }
                if (columnId === "leadOrigin") {
                    columnValue = quote.leadOrigin || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = [
                        { id: "", label: "Select" },
                        ...leadOriginOptions.map(option => ({ id: option, label: option }))
                    ];
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null
                }
                if (columnId === "leadSource") {
                    columnValue = quote.leadSource || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = [
                        { id: "", label: "Select" },
                        ...leadSourceOptions.map(option => ({ id: option, label: option }))
                    ];
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null
                }
                if (columnId === "npsSurveySent") {
                    columnValue = quote.npsSurveySent || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = npsSurveySentOptions;
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null
                }
                if (columnId === "reportingYear") {
                    columnValue = quote.reportingYear || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = [{ id: "", label: "Select year" }, ...getReportingYearOptions(quote.createdDate)];
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null
                }
                if (columnId === "reportingQuarter") {
                    columnValue = quote.reportingQuarter || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = [{ id: "", label: "Select quarter" }, ...getReportingQuarterOptions(quote.reportingYear)];
                    isDisabled = !quote.reportingYear ? true : false;
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null
                }
                if (columnId === "rejectionReason") {
                    columnValue = quote.rejectionReason || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = [{ id: "", label: "Select reason" }, ...getRejectionReasonOptions()];
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null
                }
                if (columnId === "ctResponsible") {
                    columnValue = quote.ctResponsible || ""
                    columnValueData = { ...column.data, options: getControlTowerList() || [] };
                    columnValueData.defaultValue = columnValue;
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null
                }
                else if (columnId === "hpFileUploadStatus") {
                    columnValue = getStatusDescriptionFromStatusValue(quote.hpFileUploadStatus) || '';
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    isDisabled = true;
                    if (quote.quoteType === 'DRS_REVITALIZE') {
                        if (quote.hpFileUploadStatus === 'PENDING') {
                            isDisabled = false;
                            columnValueData.options = [{ id: quote.hpFileUploadStatus, label: columnValue }, ...revitalizeHPPricesPendingOptions]
                        } else if (quote.hpFileUploadStatus === 'REQUESTED') {
                            isDisabled = false;
                            columnValueData.options = [{ id: "REQUESTED", label: "Requested" }]
                        } else if (quote.hpFileUploadStatus === 'PROVIDED') {
                            columnValueData.options = [{ id: "PROVIDED", label: "Provided" }]
                        }
                        clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null
                    }
                }
            }

            if (columnDataType === "input") {
                clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null
                if (columnId === "contactPersonEmail") {
                    columnValue = quote.contactPersonEmail || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                }
                else if (columnId === "customerName") {
                    columnValue = quote.customerName;
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    isDisabled = !quote.companyOrgIdEditable;
                }
                else if (columnId === "orgId") {
                    columnValue = quote.orgId || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    isDisabled = !quote.companyOrgIdEditable;
                }
                else if (columnId === "salesPersonEmail") {
                    columnValue = quote.salesPersonEmail || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                }
                else if (columnId === "quotationSubmissionDate") {
                    columnValue = getDateWithSpecificFormat(quote.quotationSubmissionDate) || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.disableBeforeDates = [quote.requestDate];
                }
                else if (columnId === "dateSurveySent") {
                    columnValue = getDateWithSpecificFormat(quote.dateSurveySent) || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    isDisabled = quote.npsSurveySent === "YES" ? false : true;
                }
                else if (columnId === "winningDeliveryPartner") {
                    columnValue = quote.status === "ACCEPTED" ? (quote.winningDeliveryPartner && quote.winningDeliveryPartner.length ? quote.winningDeliveryPartner.filter(option => option).join(",") : "") : "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                }
                else if (columnId === "quoteAcceptRejectDate") {
                    columnValue = quote.quoteAcceptRejectDate ? format(new Date(quote.quoteAcceptRejectDate), "yyyy-MM-dd") : "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.disableBeforeDates = [quote.quoteCreationDate];
                    isDisabled = true;
                    const originalQuote = quoteListCopy.find(orgQuote => orgQuote.quoteId === quote.quoteId) || {};
                    if (originalQuote.status !== quote.status && QUOTE_EDIT_DISABLED.includes(quote.status)) {
                        isDisabled = false;
                    }
                }
            }
            else if (columnId === "status") {
                columnValue = getStatusDescriptionFromStatusValue(quote.status) || "";
                columnValueData = { ...column.data };
                columnValueData.defaultValue = columnValue;
                columnValueData.options = [{ id: quote.status, label: columnValue }];

                if (quote.status == "CREATED") {
                    columnValueData.options = [...columnValueData.options, ...createdStatusOptions];
                } else if (quote.status == "PARTIALLY_CREATED") {
                    columnValueData.options = [...columnValueData.options, ...partiallyCreatedStatusOptions];
                } else if (quote.status === "POSTPONED_TO_NEXT_QUARTER") {
                    if (quote.partialQuote === true) {
                        columnValueData.options = [
                            ...columnValueData.options,
                            { id: "PARTIALLY_CREATED", label: "Partially Created" },
                            ...postponedToNextQuarterStatusOptions];
                    } else {
                        columnValueData.options = [
                            ...columnValueData.options,
                            { id: "CREATED", label: "Created" },
                            ...postponedToNextQuarterStatusOptions
                        ];
                    }
                }
                else if (quote.status === "VENDOR_PRICES_PROVIDED") {
                    columnValueData.options = [...columnValueData.options];
                }
                else if (quote.status === "VENDOR_PRICES_PENDING") {
                    columnValueData.options = [...columnValueData.options, ...vendorPricesPendingStatusOptions];
                }
                else if (quote.status === "ON_HOLD") {
                    if (quote.quoteCreationDate !== null) {
                        columnValueData.options = [...columnValueData.options, ...onHoldStatusCreationOptions];
                    }
                    else {
                        columnValueData.options = [...columnValueData.options, ...onHoldStatusOptions];
                    }
                }

                const originalQuote = quoteListCopy.find(orgQuote => orgQuote.quoteId === quote.quoteId) || {};
                if (originalQuote.status === quote.status && QUOTE_EDIT_DISABLED.includes(quote.status)) {
                    isDisabled = true;
                }

                clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null
            }

            row.push({
                [columnId]: {
                    id: columnId + "|" + rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValueData || columnValue,
                    width: column.width,
                    disabled: isDisabled,
                    isOverflowingContent: isOverflowingContent,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: highlightColumn,
                    linkDestination: linkDestination,
                    clickHandler: clickHandler
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
